import React, { useState, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import { loginAsync } from "../redux/authApi";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { PASSWORD_REGEX } from "../../../utils/constants";

const initialValues = {
  emailId: "",
  password: "",
};

function Login(props) {
  const [passwordShown, setPasswordShown] = useState(false);
  //for password visibality
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const { intl } = props;
  const history = useHistory();

  const { user, flashMessage, isLoading, twoFATempData } = useSelector(
    (state) => state.auth,
    shallowEqual
  );
  
  // Redirect to OTP page if 2FA is required
  useEffect(() => {
    if (twoFATempData) {
      history.push("/auth/verify-otp");
    }
  }, [twoFATempData, history]);
  //formik validation schema
  const LoginSchema = Yup.object().shape({
    emailId: Yup.string()
      .trim()
      .email("Enter valid email")
      .required("Email Id is required"),
    password: Yup.string()
      .required("Password is required.")
      .trim()
      .matches(
        PASSWORD_REGEX,
        "Password should contain min 6 and max 32 characters with atleast one Alphanumeric and special character."
      ),
  });
  //set classes with validations
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus }) => {
      try {
        //call login api
        dispatch(
          loginAsync({
            email: values.emailId,
            password: values.password,
          })
        );
      } catch (error) {
        setStatus(
          intl.formatMessage({
            id: "AUTH.VALIDATION.INVALID_LOGIN",
          })
        );
      }
    },
  });
  //redirect to verification page (old flow)
  if (user && user.twoFactorAuthentication && !twoFATempData) {
    return <Redirect to="/auth/verification" />;
  }
  
  // Redirect to OTP page if 2FA temp data exists
  if (twoFATempData) {
    return <Redirect to="/auth/verify-otp" />;
  }
  
  // Redirect to dashboard if already logged in
  if (user && user._id && !twoFATempData) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1 text-white">
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </h3>
        <p className="text-muted font-weight-bold">
          Enter your email and password
        </p>
      </div>
      {/* end::Head */}
      {flashMessage ? (
        <div
          className="mb-10 alert alert-custom alert-light-danger alert-dismissible"
          style={{ margin: "auto" }}
        >
          <div className="alert-text font-weight-bold">{flashMessage}</div>
        </div>
      ) : null}
      {/*begin::Form*/}
      <form
        autoComplete="off"
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : null}
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Email"
            type="email"
            className={`form-control form-control-solid h-auto py-5 px-2  border-less-input text-white ${getInputClasses(
              "email"
            )}`}
            name="emailId"
            autoComplete="new-email"
            {...formik.getFieldProps("emailId")}
          />
          {formik.touched.emailId && formik.errors.emailId ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.emailId}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <div className="frpsswrd">
            <input
              placeholder="Password"
              type={passwordShown ? "text" : "password"}
              className={`form-control form-control-solid px-2 border-less-input text-white `}
              name="password"
              autoComplete="new-password"
              {...formik.getFieldProps("password")}
              style={{ paddingRight: "50px" }}
            />
            <i
              onClick={togglePasswordVisiblity}
              className="far fa-eye-slash"
            ></i>
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
          </Link>
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={isLoading}
            className={`btn btn-blue btn_new ${!isLoading ? "" : "lodingTime"}`}
          >
            <span>Continue</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(Login);
